module.exports = __webpack_public_path__ + "img/Wild-Turkey.fe9abdec.jpg";